import { Card, Typography } from 'antd'
import React from 'react'
import { PageInfo } from '../types'
import './Overview.less'

const { Title } = Typography

interface OverviewProps {
  pageInfo?: PageInfo
  isProvider?: boolean
}

// 趋势图标组件
const TrendIcon: React.FC<{ direction?: 'up' | 'down' }> = ({ direction = 'up' }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      {direction === 'up' ? (
        <path d="M2 12 L6 8 L9 11 L14 6" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
      ) : (
        <path d="M2 6 L6 10 L9 7 L14 12" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
      )}
    </svg>
  )
}

const Overview: React.FC<OverviewProps> = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  pageInfo,
  isProvider,
}) => {
  if (pageInfo === null || pageInfo === undefined) {
    return (
      <Card
        title={<Title style={titleStyle} level={3}>平台概述</Title>}
        className="overview"
      >
        <div style={{ textAlign: 'center', padding: '40px 0', color: '#999' }}>无数据</div>
      </Card>
    );
  }

  return (<> 
    <Card
      title={  <Title style={titleStyle} level={3}>平台概述</Title>}
      className="overview"
    >
      <Card.Grid
        style={gridStyle}
        hoverable={false}
        className="overview-card"
      >
        <OverviewItem
          title="产品数"
          count={pageInfo?.product.total}
          infoList={[
            { title: '已发布', value: `${pageInfo?.product.release_total}个` },
            { title: '未发布', value: `${pageInfo?.product.unreleased_total}个` },
          ]}
        />
      </Card.Grid>
      <Card.Grid
        style={gridStyle}
        hoverable={false}
        className="overview-card"
      >
        <OverviewItem
          title="设备数"
          count={pageInfo?.device.total}
          infoList={[
            { title: '在线', value: `${pageInfo?.device.online_total}个` },
            { title: '离线', value: `${pageInfo?.device.offline_total}个` },
          ]}
        />
      </Card.Grid>
      {!isProvider && (
      <Card.Grid
        style={gridStyle}
        hoverable={false}
        className="overview-card"
      >
        <OverviewItem
          title="驱动数"
          count={pageInfo?.driverInstance.count}
          infoList={[
            { title: '运行中', value: `${pageInfo?.driverInstance.run_count}个` },
            { title: '已停止', value: `${pageInfo?.driverInstance.stop_count}个` },
          ]}
        />
      </Card.Grid>
      )}
      <Card.Grid
        style={gridStyle}
        hoverable={false}
        className="overview-card"
      >
        <OverviewItem
          title="告警数"
          count={pageInfo?.alert.total}
          infoList={[
            { title: '数据统计截止昨日24时', value: ' ' },
          ]}
        />
      </Card.Grid>
    </Card>
  </>)
}

interface OverviewItemProps {
  title?: string
  count?: number
  infoList?: { title: string, value?: string }[]
}

const gridStyle: React.CSSProperties = {
  flex: '1 1 0',
  minWidth: 0,
}

const titleStyle: React.CSSProperties = {
  marginTop: '10px',
  marginBottom: '10px',
  fontSize: '16px',
}


const OverviewItem: React.FC<OverviewItemProps> = (props) => {
  return (
    <div className="overview-item">
      <div className="overview-item__title">{props.title}</div>
      <div className="overview-item__content">
        <div className="overview-item__count">{props.count || 0}</div>
        <div className="overview-item__info-list">
          {(props.infoList || []).map(({ title, value }, index) => (
            <div key={index} className="overview-item__info">
              <span className="overview-item__info-text">{title} {value}</span>
              <TrendIcon direction="up" />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Overview
